<template>
  <div class="drawer">
    <div class="side">
      <div class="mainDiv">
        <div class="topDiv flex" v-if="navSeleIndex == 0">
          <div id="imageList" class="tops flex">
            <div class="imgcasesT" ref="mySwipers">
              <div class="gd-slides">
                <div style="height: 100%; width: 100%" class="flex">
                  <c360 ref="v3" />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="swiper-button-next" @click="nexts()"></div>
          <div class="swiper-button-prev" @click="prevs()"></div> -->
        </div>
        <xc-video v-if="navSeleIndex == 1"></xc-video>
        <div class="topDiv flex" v-if="navSeleIndex == 2">
          <div id="imageList" class="tops flex">
            <div class="imgcasesT" ref="mySwipers">
              <div class="gd-slides">
                <div style="height: 100%; width: 100%" class="flex">
                  <cssk ref="sk" />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next" @click="sknexts()"></div>
          <div class="swiper-button-prev" @click="skprevs()"></div>
        </div>
        <div class="botDiv flex">
          <div
            v-for="(it, index) in navList"
            :key="index"
            class="botNav flex"
            :style="{ color: navSeleIndex == index ? '#fff' : '#e5e5e5' }"
            @click="selClick(index)"
          >
            {{ it.name }}
            <div class="lines" v-if="navSeleIndex == index"></div>
            <div class="sjx flex" v-if="navSeleIndex == index">
              <img
                style="transform: rotate(270deg)"
                src="~images/video/xz.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const c360 = () => import("./c360");
const cssk = () => import("./cssk");
const xcVideo = () => import("./xcvideo");
// import { videoPlayer } from "vue-video-player";
// import "video.js/dist/video-js.css";
// import "vue-video-player/src/custom-theme.css";
import "swiper/dist/css/swiper.css";
import "swiper/dist/js/swiper.min";
import Swiper from "swiper";
export default {
  components: { c360, cssk, xcVideo },
  computed: {},
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  watch: {
    index: {
      handler(v) {
        this.navSeleIndex = v;
      },
      immediate: true
    }
  },
  data() {
    return {
      cShow: false,
      seleIndex: 0,
      list: [],
      xzIndex: 0,
      navSeleIndex: 0,
      navList: [
        {
          name: "视频监控"
        },
        {
          name: "产业宣传"
        },
        {
          name: "采收实况"
        }
      ],
      videoDialogVisible: false, // 控制弹出层
      events: ["fullscreenchange"]
    };
  },
  mounted() {
    this.v3 = this.$refs.v3;
    this.getNh();
    // this.$nextTick(() => {
    //   this.initSwiper();
    // });
  },
  methods: {
    getNh() {
      const userAgent = navigator.userAgent.toLocaleLowerCase();
      if (userAgent.match(/chrome/) != null) {
        if (userAgent.match(/wow64/) != null) {
          this.cShow = true;
        } else if (userAgent.match(/edg/) != null) {
          this.cShow = false;
        } else {
          this.cShow = false;
        }
      }
    },
    prevs() {
      if (!this.v3) {
        this.v3 = this.$refs.v3;
      }
      this.v3.prevs();
    },
    nexts() {
      if (!this.v3) {
        this.v3 = this.$refs.v3;
      }
      this.v3.nexts();
    },
    skprevs() {
      if (!this.sk) {
        this.sk = this.$refs.sk;
      }
      this.sk.prevs();
    },
    sknexts() {
      if (!this.sk) {
        this.sk = this.$refs.sk;
      }
      this.sk.nexts();
    },
    selClick(index) {
      this.navSeleIndex = index;
    },
    initSwiper() {
      this.$nextTick(function() {
        new Swiper(".swiper-container-video", {
          // autoplay: 2500, // 可选选项，自动滑动
          navigation: {
            nextEl: ".swiper-button-next_1",
            prevEl: ".swiper-button-prev_1"
          },
          thumbs: {
            swiper: {
              el: "#thumbs",
              spaceBetween: 10,
              slidesPerView: 3,
              observer: true,
              direction: "vertical",
              watchSlidesVisibility: true /* 避免出现bug*/,
              centeredSlides: false
            }
          },
          on: {
            slideChange: () => {}
          }
        });
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.side
  position absolute
  bottom 0
  top 105px
  bottom 0
  z-index 9
  width 100%
  background-color rgba(9, 26, 54, 0.8)
  color #fff
  @media (max-width 1366px)
    top 55px
.mainDiv
  width calc(100% - 60px)
  height calc(100% - 20px)
  margin 10px 30px
  font-size 0.06rem
.topDiv
  height calc(100% - 48px)
  width 100%
.botDiv
  height 45px
  width calc(100% - 40px)
  margin 10px 22px 0 18px
  border-top 3px #000102 solid
.flex
  display flex
  align-items center
.leftDiv
  width 20%
  margin-right 18px
  height 100%
  justify-content center
.rightDiv
  width calc(80% - 18px)
  height 100%
  background url('~images/video/bg-video.png') no-repeat center
  background-size 100% 100%
.tops
  position relative
  height calc(100% - 0px)
  width 98%
  margin 0 1%
  overflow hidden
  z-index 9
.imgcasesT
  width 100%
  position relative
  overflow initial
  margin 0
  height 100%
  z-index 990
  &::-webkit-scrollbar
    width 4px
    background-color #00162D
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color $textColor
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
.gd-slides
  display flex
  align-content center
  justify-content center
  flex-direction column
  z-index 9
  width 100%
  height 100%
.swiper-button-next, .swiper-container-rtl .swiper-button-prev
  right 8px
  left auto
.swiper-button-prev, .swiper-container-rtl .swiper-button-next
  left 6px
  right auto
.swiper-button-prev
  background url('~images/video/left.png') center no-repeat
  background-size 100% 100%
.swiper-button-next
  background url('~images/video/right.png') center no-repeat
  background-size 100% 100%
.swiper-button-prev, .swiper-button-next
  position absolute
  top 49%
  width 40px
  height 53px
  margin-top -22px
  z-index 100
  cursor pointer
  background-position center
.schoolRank
  width 100%
  height 100%
  display flex
  justify-content center
.ysList
  width calc(100% - 5px)
  position relative
  margin-bottom 10px
  margin-right 5px
  cursor pointer
.ysList:last-child
  margin-bottom 0px
.tableBody
  height calc(100% - 30px)
  overflow auto
  width calc(100% - 25px)
  border 1px #0E274C solid
  padding 14px 10px 14px 15px
  &::-webkit-scrollbar
    width 4px
    background-color #030814
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color #377DC0
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
.sp_wz
  color #fff
  font-size 0.07rem
  width 100%
  justify-content center
  display flex
  align-items flex-end
.videobox
  height 100%
  width calc(100% - 0px)
  border-radius 10px
>>>video
  width 100% !important
.contMain
  height calc(100% - 20px)
  width calc(100% - 40px)
  margin 10px 20px
.topRight
  width 100%
  height 7%
  color #fff
.botRight
  width 100%
  height 93%
  color #fff
.titleName
  font-size 0.12rem
  font-weight 500
  letter-spacing 2px
  background-image -webkit-linear-gradient(top, #EAF5FA, #0AA5F2)
  -webkit-background-clip text
  -webkit-text-fill-color transparent
.titleLine
  width 60%
.titleImg
  position absolute
  top 0.01rem
  right 0.1rem
  cursor pointer
  height 7%
.botNav
  position relative
  height 100%
  width 0.5rem
  font-size 0.08rem
  justify-content center
  cursor pointer
.lines
  width 100%
  height 2px
  background #3981E0
  position absolute
  top -2.5px
  left 0
.sjx
  position absolute
  top -13px
  left 0px
  width 100%
  height 15px
  justify-content center
.sjx img
  height 100%
.videoDiv
  width calc(100% - 40px)
  height calc(100% - 20px)
  padding 10px 20px
  justify-content center
  flex-wrap wrap
.cover
  width 100%
  height 100%
  position absolute
  top 0
  left 0
  background rgba(30, 30, 30, 0)
.cover1
  width 100%
  height 100%
  position absolute
  top 0
  left 0
  background rgba(30, 30, 30, 0.32)
.videoNav
  background url('~images/video/video_nav.png') no-repeat center
  background-size 100% 100%
.wzNav
  background url('~images/video/wz_nav.png') no-repeat center
  background-size 100% 100%
.topTitle
  height 25%
  width 100%
  display flex
  align-items flex-end
  justify-content flex-end
  position relative
.botTitle
  height 75%
  width 100%
.xcTop
  background url('~images/video/title-right.png') no-repeat center
  background-size 100% 100%
  height 60%
  width 45%
  justify-content center
  letter-spacing 2px
  font-size 0.06rem
.circle
  position absolute
  bottom -0.1rem
  left -0.1rem
  width 0.3rem
  height 0.3rem
  background rgba(13, 35, 82, 1)
.circle_x
  position relative
  top 0.01rem
  width 0.2rem
  height 0.2rem
  left 22%
.arround
  position absolute
  width 0.2rem
  height 0.2rem
  top 25%
  left 0
  animation rotation 5s linear infinite
  -moz-animation rotation 5s linear infinite
  -webkit-animation rotation 5s linear infinite
  -o-animation rotation 5s linear infinite
@keyframes rotation
  from
    -webkit-transform rotate(0deg)
  to
    -webkit-transform rotate(360deg)
.circle_zj
  position absolute
  top 25%
  left 0
  width 100%
  height 100%
  justify-content center
.num
  font-size 0.12rem
.spDiv
  width 100%
  height 100%
  justify-content center
  font-size 0.2rem
  letter-spacing 5px

.swiper-box
      height 100%
      width 100%
      // margin-top 16px
      .bswiper
        display flex
        width 100%
        height 100%
        padding 0 10px
        box-sizing border-box
        .thumbs-box
          height 100%
          width 20%
          display flex
          align-items center
          #thumbs
            width 100%
            height 100%
            overflow hidden
            .swiper-wrapper
              >>>.swiper-slide
                width 95%
                height 30% !important
                opacity 0.6
                margin-bottom 10px
                box-sizing border-box
                img
                  display block
                  width 80%
                  height 80%
                  margin 6% auto
                  border 2px solid #0e6079
                  // height 62px
              .swiper-slide-thumb-active
                opacity 1
        .right-swiper-box
          // width calc(100% - 120px)
          height 100%
          position relative
          display flex
          align-items center
          justify-content center
          margin-left 10px
          // background #041649
          // border-right 4px solid #00aeff
          // border-left 4px solid #00aeff
          .swiper-title
            line-height 40px
            font-size 16px
            text-align center
            color #fff
          .swiper-container
            width 90%
            height 90%
            >>>.swiper-wrapper
                .swiper-slide
                  img
                    width 260px
                    height 190px
          .swiper-button-prev,.swiper-button-next
            width 40px
            height 53px
            margin-top 14px
          .swiper-button-prev:after, .swiper-button-next:after
            display none
          .swiper-button-prev_1
            left 12px
            background url('~images/video/left.png') no-repeat center
            background-size 100% 100%
          .swiper-button-next_1
            right 12px
            background url('~images/video/right.png') no-repeat center
            background-size 100% 100%
  .center-line
    position relative
    width 1px
    height 100%
    background #0559a3
    .light-line
      position absolute
      top 50%
      left 0
      width 1px
      height 97px
      margin-top -48.5px
      background #00aeff
</style>
<style>
.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  height: 100% !important;
  padding-top: 0 !important;
  width: 100% !important;
}
.vjs-tech {
  width: 100% !important;
  height: 100% !important;
}
.vjs-poster {
  background-position: center !important;
  background-size: cover !important;
}
.dddd {
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: fill;
  border: 1px #31d5f3 solid;
}
video {
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  border: 1px #31d5f3 solid;
}
/* video{
      width: 100% !important;
      height: calc(100vh - 95px) !important;
      object-fit:fill;    //消除留白
} */
</style>
